import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ChamadoFranquiaEncerrarRoutingModule } from './chamado-franquia-encerrar-routing.module';
import { ChamadoFranquiaEncerrarComponent } from './chamado-franquia-encerrar.component';
import { MessagesModule } from 'primeng/messages';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { TooltipModule } from 'primeng/tooltip';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DialogModule } from 'primeng/dialog';
import { FormatPipeModule } from 'src/app/admihair/format-pipe/format-pipe.module';
import { CheckboxModule } from 'primeng/checkbox';


@NgModule({
  declarations: [
    ChamadoFranquiaEncerrarComponent
  ],
  imports: [
    CommonModule,
    ChamadoFranquiaEncerrarRoutingModule,
    FormsModule,
    MessagesModule,
    ButtonModule,
    DropdownModule,
    InputTextareaModule,
    TooltipModule,
    ProgressSpinnerModule,
    DialogModule,
    FormatPipeModule,
    CheckboxModule
  ]
})
export class ChamadoFranquiaEncerrarModule { }
